<template>
  <div class="langDropDown">
    <div
      :class="{ active: item.label === language }"
      class="item"
      v-for="(item, index) in langMenuList"
      :key="index"
      @click="changeLang(item.label)"
    >
      {{ item.value }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      langMenuList: [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        },
        {
          label: 'id',
          value: 'Bahasa Indonesia'
        }
      ],
      language: ''
    }
  },
  mounted () {
    this.language = localStorage.getItem('language') || this.$i18n.locale
    if (['ekyc', 'lunaAi', 'aiAds'].includes(this.$route.name)) {
      this.langMenuList = [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        }
      ]
    } else {
      this.langMenuList = [
        {
          label: 'zh',
          value: '中文'
        },
        {
          label: 'en',
          value: 'English'
        },
        {
          label: 'es',
          value: 'Español'
        },
        {
          label: 'id',
          value: 'Bahasa Indonesia'
        }
      ]
    }
  },
  methods: {
    changeLang (lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)
      window.location.reload()
    }
  }
}
</script>

<style scoped lang="less">
.langDropDown {
  background-color: rgba(255, 255, 255, 0.95);
  position: absolute;
  left: 50%;
  bottom: -0.32rem;
  transform: translateY(100%) translateX(-50%);
  padding: 0 0.586667rem /* 22/37.5 */;
  border-radius: 0.266667rem /* 10/37.5 */;
  font-weight: 400;
  .item {
    color: #242b2a;
    font-size: 0.373333rem /* 14/37.5 */;
    text-align: left;
    margin: 0.533333rem /* 20/37.5 */ 0;
  }
  .active {
    color: #07816a;
  }
}
</style>
